import './Team.css'
import ToggleButton from '../ToggleButton/ToggleButton'

const Team = ({ team, match, detailsShowing, onClick }) => {
  return (
    <div className="team">
      <div
        style={{
          backgroundColor: team.team_first_color
        }}
        className="teamColour"
      ></div>
      <div className="teamName">
        <ToggleButton toggled={detailsShowing} onClick={onClick} fullWidth>
          {team.team_name}
        </ToggleButton>
      </div>
    </div>
  )
}

export default Team
